export default __webpack_public_path__ + "static/media/prevArrow.dfddfe67.svg";